const storagePrefix = 'pakado';
let inMemoryToken: string | undefined;

export const storage = {
    getToken: () => {
        return inMemoryToken ?? JSON.parse(localStorage.getItem(`${storagePrefix}token`) as string);
    },
    setToken: (token: string, rememberMe?: boolean) => {
        // if (!rememberMe) {
        //     inMemoryToken = token;
        //     return;
        // }
        localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
    },
    clearToken: () => {
        inMemoryToken = undefined;
        localStorage.removeItem(`${storagePrefix}token`);
    }
};
